import { call, debounce, put, select } from 'redux-saga/effects'

import { globalSearch as globalSearchAPI } from 'Service/Api'

import * as GlobalSearchTypes from 'Redux/Types/GlobalSearchTypes'
import * as GlobalSearchActions from 'Redux/Actions/GlobalSearchActions'

function* globalSearch({ payload }) {
  try {
    const next = yield select(({ globalSearch }) => globalSearch.next)
    const params = payload.fetchMore ? next : 'limit=10&offset=0'
    const response = yield call(globalSearchAPI, {
      filters: { fullTextSearch: payload.search },
      params,
    })
    yield put(
      GlobalSearchActions.globalSearchSucceeded({ ...response, fetchMore: payload.fetchMore }),
    )
  } catch (error) {
    yield put(GlobalSearchActions.globalSearchFailed(error))
  }
}

export default function* JobCodeSaga() {
  yield debounce(350, GlobalSearchTypes.GLOBAL_SEARCH, globalSearch)
}
